export default __webpack_public_path__ + "static/sunilWadhwa2-5d26f26671e7e9182ecdcf89b2caef6d.jpg";